import '@/app/app.css';
import './main.css';

import { closeHeaderMenu } from '@/widgets/header/header-menu/header-menu';
import { initLinkScroll } from '@/shared/scroll/scroll';
import { SectionProduct } from '@/widgets/section/section-product/section-product';
import { SectionCare } from '@/widgets/section/section-care/section-care';

import '@/app/app';

window.addEventListener('DOMContentLoaded', () => {
	closeHeaderMenu();
	initLinkScroll();
	document.querySelectorAll('.js-section-product').forEach((element) => new SectionProduct(element));
	document.querySelectorAll('.js-section-care').forEach((element) => new SectionCare(element));
});
